module.exports = "pegasus_template/assets/themelp1/charity/111.png";